<template>
  <div class="SX">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoPartyDiscipline">党纪法规></span>
        <span @click="GoFenLei">分类系统></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
      <div class="zhengwen">
        <h1>2019－2023年全国党员教育培训工作规划</h1>
        <div class="first">
          <p>近日，中共中央办公厅印发了《2019－2023年全国党员教育培训工作规划》，并发出通知，要求各地区各部门结合实际认真贯彻落实。</p>
        </div>
        <div class="date">发布时间：2020-5-20&nbsp13:30</div>
        <div class="xh"></div>

        <div class="second">
          <strong>
            <p>一、总体要求</p>
          </strong>
          <p>党员教育培训工作，以马克思列宁主义、毛泽东思想、邓小平理论、“三个代表”重要思想、科学发展观、习近平新时代中国特色社会主义思想为指导，认真落实新时代党的建设总要求，把学习贯彻习近平新时代中国特色社会主义思想作为首要政治任务，以坚定信仰、增强党性、提高素质为重点，坚持思想建党、理论强党、从严治党，坚持围绕中心、服务大局，坚持分类指导、按需施教，坚持联系实际、继承创新，坚持简便易行、务实管用，不断增强针对性和有效性，引导党员增强“四个意识”、坚定“四个自信”、做到“两个维护”，努力建设政治合格、执行纪律合格、品德合格、发挥作用合格的党员队伍。</p>

          <p>从2019年开始，用5年时间，有计划分层次高质量开展党员教育培训，把全体党员普遍轮训一遍，实现以下工作目标。</p>

          <p>——习近平新时代中国特色社会主义思想学习教育更加扎实深入，党的创新理论更加入脑入心，广大党员自觉践行新思想、适应新时代、展现新作为，在习近平新时代中国特色社会主义思想指引下，统一意志、统一行动、步调一致向前进。</p>

          <p>——教育培训效果更加显著，广大党员理想信念进一步坚定、党性观念进一步增强、宗旨意识进一步强化、能力素质进一步提升、纪律作风进一步过硬、先锋模范作用进一步发挥。</p>

          <p>——新时代党员教育培训体系更加健全，集中培训逐步走向常态，日常教育更加规范，推动形成教育和管理、监督、服务有机结合的党员队伍建设工作链条。</p>
          <strong>
            <p>二、习近平新时代中国特色社会主义思想教育培训</p>
          </strong>
          <p>（一）把学习贯彻习近平新时代中国特色社会主义思想作为首要政治任务。各级党组织要将习近平新时代中国特色社会主义思想学习教育摆在党员教育培训最突出位置，县级以上党委每年制定学习计划，列出必读书目和篇目，明确学习要求，基层党组织要结合党员日常教育管理认真抓好落实。党员教育培训机构要将习近平新时代中国特色社会主义思想作为主课，全面纳入教学计划和教学布局。党员要把习近平新时代中国特色社会主义思想作为必修课，读原著、学原文、悟原理，深刻理解习近平新时代中国特色社会主义思想的重大意义、科学体系、丰富内涵、精神实质、实践要求，掌握贯穿其中的马克思主义立场观点方法，增强政治自觉、理论自信、情感融入，做到真学真懂真信真用。</p>

          <p>（二）建立健全习近平新时代中国特色社会主义思想学习教育长效机制。以习近平新时代中国特色社会主义思想为中心内容，建立较为完备的课程体系。加强理论教育特点和规律的研究，开发一批学习贯彻习近平新时代中国特色社会主义思想的教学案例和现场教学点。通过专题讲座、报告会、学习论坛等多种形式进行深入浅出的解读阐述，领导干部要结合分管领域、分管工作带头宣讲。发挥“两微一端”等新媒体优势，组织党员在线学习。注重发挥党支部直接教育党员的作用，落实“三会一课”等制度，对党员开展经常性教育。健全理论学习考核评估制度，采取有效措施激发党员学习热情，推动学习教育往深里走、往心里走、往实里走。</p>
          <p>（三）引导党员自觉做习近平新时代中国特色社会主义思想坚定信仰者和忠实实践者。弘扬理论联系实际的马克思主义学风，引导党员把自己摆进去、把职责摆进去、把工作摆进去，对照习近平新时代中国特色社会主义思想检视思想言行，做到学思用贯通、知信行统一。引导党员结合岗位职责，认真学习贯彻习近平总书记关于本部门本行业本领域工作的重要论述和重要指示批示精神，提高运用科学理论解决实际问题能力，更好推动事业发展。大力选树和宣传学懂弄通做实的先进典型，引导党员自觉用习近平新时代中国特色社会主义思想武装头脑、指导实践、推动工作。党员领导干部应当坚持更高标准、更严要求，带头学习实践习近平新时代中国特色社会主义思想。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    GoPartyDiscipline() {
      this.$router.push("/PartyDiscipline");
    },
    GoFenLei() {
      this.$router.push("/PartyDiscipline/FenLei");
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.first p {
  font-weight: 600;
}
.date{
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-bottom: 28px;
}
</style>